{
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "$id": "https://augmented.dev/schemas/plugin-context.meta.schema.json",
    "title": "Integration Context Schema (meta)",
    "description": "Meta-schema for the constrained subset of JSON Schema that plugin authors may declare for their plugin context. Anything outside this subset is rejected at PUT time. See ENG-4341 / docs/plugins/plugin-context-rfc.md.",
    "type": "object",
    "required": ["type", "properties"],
    "additionalProperties": false,
    "properties": {
        "$schema": {
            "type": "string"
        },
        "type": {
            "type": "string",
            "const": "object"
        },
        "properties": {
            "type": "object",
            "minProperties": 0,
            "additionalProperties": {
                "$ref": "#/$defs/field"
            }
        },
        "required": {
            "type": "array",
            "items": { "type": "string" },
            "uniqueItems": true
        }
    },
    "$defs": {
        "field": {
            "oneOf": [
                { "$ref": "#/$defs/stringField" },
                { "$ref": "#/$defs/booleanField" },
                { "$ref": "#/$defs/stringArrayField" },
                { "$ref": "#/$defs/stringMapField" }
            ]
        },
        "stringField": {
            "type": "object",
            "required": ["type"],
            "additionalProperties": false,
            "properties": {
                "type": { "const": "string" },
                "title": { "type": "string" },
                "description": { "type": "string" },
                "enum": {
                    "type": "array",
                    "items": { "type": "string" },
                    "minItems": 1,
                    "uniqueItems": true
                },
                "default": { "type": "string" }
            }
        },
        "booleanField": {
            "type": "object",
            "required": ["type"],
            "additionalProperties": false,
            "properties": {
                "type": { "const": "boolean" },
                "title": { "type": "string" },
                "description": { "type": "string" },
                "default": { "type": "boolean" }
            }
        },
        "stringArrayField": {
            "type": "object",
            "required": ["type", "items"],
            "additionalProperties": false,
            "properties": {
                "type": { "const": "array" },
                "items": {
                    "type": "object",
                    "required": ["type"],
                    "additionalProperties": false,
                    "properties": {
                        "type": { "const": "string" }
                    }
                },
                "title": { "type": "string" },
                "description": { "type": "string" },
                "default": {
                    "type": "array",
                    "items": { "type": "string" }
                }
            }
        },
        "stringMapField": {
            "type": "object",
            "required": ["type", "additionalProperties"],
            "additionalProperties": false,
            "properties": {
                "type": { "const": "object" },
                "additionalProperties": {
                    "type": "object",
                    "required": ["type"],
                    "additionalProperties": false,
                    "properties": {
                        "type": { "const": "string" }
                    }
                },
                "title": { "type": "string" },
                "description": { "type": "string" },
                "default": {
                    "type": "object",
                    "additionalProperties": { "type": "string" }
                }
            }
        }
    }
}
